import { ReactNode, useEffect, useState } from "react";
import TopBar from "./topbar/TopBar";
import { GlobalLoader } from "./GlobalLoader";
import Sidebar from "./sidebar/Sidebar";

const SideBarWrapper = ({ children }: { children: ReactNode }) => {
  const [selected, setSelected] = useState<boolean>(() => {
    const storedValue = localStorage.getItem('show-menu');
    return storedValue ? storedValue === 'true' : false;
  });

  const toggleSelected = () => {
    setSelected(prevSelected => !prevSelected);
  };

  useEffect(() => {
    if (selected) {
      document.body.classList.add('show-menu');
    } else {
      document.body.classList.remove('show-menu');
    }
    localStorage.setItem('show-menu', String(selected));
  }, [selected]);


  return (
    <div className='lg:min-h-screen bg-[#FAFDFF] flex flex-col relative'>
      <Sidebar selected={selected} setSelected={setSelected} />
      <div className={`flex flex-col flex-1 transition-all duration-300 h-full ${selected ? 'lg:pl-[54px_!important]' : 'lg:pl-[280px_!important]'}`} >
        <div className="flex-1 flex flex-col min-h-full">
          <TopBar toggleSelected={toggleSelected} />
          <div className="relative flex-1 flex flex-col">
            <GlobalLoader isStartup={false} />
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default SideBarWrapper
